import { useCallback, useEffect } from 'react';

import { useApiGet } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';

export default function useGetStudyIsFavorite(userId: number, studyId: number) {
  const { data, isLoading, error, get } = useApiGet<boolean>(
    `users/${userId}/favorite/study/${studyId}`
  );
  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Get study template favorite error', error)),
    [error, logError]
  );

  const getStudyIsFavorite = useCallback(() => get(), [get]);
  return {
    studyIsFavorite: data,
    studyIsFavoriteLoading: isLoading,
    studyIsFavoriteError: error,
    getStudyFavorite: getStudyIsFavorite
  };
}
